import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { DtoContentBlock, DtoPage } from '@common';
import { Subscription } from 'rxjs';
import { ContentService } from '../../../core';
import { ClearCookieFormComponent } from '../clear-cookie-form/clear-cookie-form.component';
import { ContactFormComponent } from '../contact-form/contact-form.component';
import { SelfServiceFormComponent } from '../self-service-form/self-service-form.component';
import { ContentContentComponent } from './content-content/content-content.component';
import { ContentQuotationComponent } from './content-quotation/content-quotation.component';
import { ContentWordDefinitionComponent } from './content-word-definition/content-word-definition.component';

@Component({
  selector: 'app-content-page',
  imports: [
    CommonModule,
    MatCardModule,
    ContentWordDefinitionComponent,
    ContentContentComponent,
    ContactFormComponent,
    ClearCookieFormComponent,
    SelfServiceFormComponent,
    ContentQuotationComponent
  ],
  templateUrl: './content-page.component.html',
  styleUrls: ['./content-page.component.scss']
})
export class ContentPageComponent implements OnInit, OnDestroy {
  //#region private fields ----------------------------------------------------
  private readonly route: ActivatedRoute;
  private readonly contentService: ContentService;
  private readonly titleService: Title;
  private routeSubscription!: Subscription;
  private contentSubscription!: Subscription;
  //#endregion

  //#region Protected Fields --------------------------------------------------
  protected page!: DtoPage;
  //#endregion

  //#region Constructor & C° --------------------------------------------------
  public constructor(route: ActivatedRoute, titleService: Title, contentService: ContentService) {
    this.route = route;
    this.titleService = titleService;
    this.contentService = contentService;
  }

  public ngOnInit(): void {
    this.routeSubscription = this.contentService.getContent.subscribe((page: DtoPage) => {
      page.blocks.sort((a: DtoContentBlock, b: DtoContentBlock) => a.sequence - b.sequence);
      this.page = page;
      const newTitle = page.windowTitle ? `Der e-coach: ${page.windowTitle}` : 'Der e-coach';
      this.titleService.setTitle(newTitle);
    });

    this.contentSubscription = this.route.queryParams.subscribe((params: Params) => {
      const content: string = <string>params['content'] || 'home';
      this.contentService.currentPath = content;
    });
  }

  public ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.contentSubscription.unsubscribe();
  }
  //#endregion
}
